<script>
  import Input from "./Input.svelte";

  const pattern = "[\\d]{10,15}";
</script>

<Input type="text" {pattern} on:focus on:invalid on:click {...$$restProps}>
  <slot />
</Input>
